import React, { FunctionComponent } from 'react';
import { InfMapIcon } from 'app/assets/images/icons';
import styles from './InfluencerIcon.module.scss';

interface Props {
  name: string;
  viewUrl: string;
  image_url?: string;
}
const InfluencerIcon: FunctionComponent<Props> = ({
  name,
  image_url,
  viewUrl,
}) => {
  return (
    <a href={viewUrl} rel="noreferrer">
      <div className={styles.InfluencerIcon}>
        {image_url ? (
          <img src={image_url} alt="influencer pic" data-testid="img-holder" />
        ) : (
          <InfMapIcon data-testid="icon-holder" />
        )}
        <span
          style={{
            display: 'inline-block',
            fontFamily: 'LatoRegular, sans-serif',
            fontSize: '10px',
          }}
          data-testid="name-holder"
        >
          {name}
        </span>
        <div />
      </div>
    </a>
  );
};
export default InfluencerIcon;
